import { gql } from '@apollo/client'
import { PICOS_PRIORITY_FRAGMENT } from '../fragments'

export const GET_PICOS_PRIORITIES = gql`
  query PicOSPriorities($input: PicOSPriorityInput!) {
    picosPriorities(input: $input) {
      count
      hasMore
      results {
        ...PicOSPriority
      }
    }
  }
  ${PICOS_PRIORITY_FRAGMENT}
`
